export const BSKY_LABELER_DID = 'did:plc:ar7c4by46qjdydhdevvrndac'
